import React, { useState } from 'react'
import { INITIAL_VALUES } from './form'
import { useErrorHandling } from 'context/errorHandling'
import { SuccessDialog } from 'components/Shared/Dialogs'
import { useTranslation } from 'react-i18next'
import CustomFieldsForm from 'components/CustomFields/CustomFieldsForm/CustomFieldsForm'
import { createCustomField } from 'services/CustomFieldService'
import { useNavigatePrevent } from 'context/navigatePrevent'

export function CustomFieldsCreateForm () {
  const [successDialogOpen, setSuccessDialogOpen] = useState(false)

  const { t } = useTranslation()
  const { handleError } = useErrorHandling()
  const { setNavigationUnlocked } = useNavigatePrevent()

  const handleSubmit = values => {
    createCustomField(values)
      .then(() => setSuccessDialogOpen(true))
      .catch(handleError)
  }

  const handleSuccessDialogClose = () => {
    setSuccessDialogOpen(false)
    setNavigationUnlocked(history => history.push('/custom-fields'))
  }

  return (
    <>
      <SuccessDialog
        content='customField.form.create.onSuccessMessage'
        open={successDialogOpen}
        onClose={handleSuccessDialogClose}
      />
      <CustomFieldsForm
        onSubmit={handleSubmit}
        initialValues={INITIAL_VALUES}
        title={t('customField.form.create.title')}
      />
    </>
  )
}
